export default "__VITE_ASSET__BYK8yerD__"